import { request } from '@/api/apiUtils';
import { createEntityQuery } from '@/data/createEntityQuery';
import type { EntityDefinition, FetcherEntry } from '@/data/types';
import type { ICharacterRelationType } from '@/types';

/** Root: query-key prefix for this entity's slice of the cache (ADR 0010). */
export const RELATION_TYPES_ROOT = ['relation-types'] as const;

interface RelationTypesListParams {
    projectId: number;
    version?: string;
}

const fetchers = {
    /** The project's own relationship types (#1847), oldest first — the
     *  built-in four are the client's and never come from here. Unpaginated:
     *  a project holds a handful. */
    list: {
        key: ({ projectId, version }: RelationTypesListParams) => [...RELATION_TYPES_ROOT, 'list', { projectId, version }] as const,
        fetch: async ({ projectId, version }: RelationTypesListParams): Promise<ICharacterRelationType[]> => {
            const query = version ? `?${new URLSearchParams({ version })}` : '';
            const response: { data: ICharacterRelationType[] } = await request(`projects/${projectId}/character-relation-types${query}`);
            return response.data;
        },
    },
    // biome-ignore lint/suspicious/noExplicitAny: required for generic type inference
} satisfies Record<string, FetcherEntry<any, any>>;

export const relationTypesEntity: EntityDefinition<typeof fetchers> = {
    name: 'relationTypes',
    roots: [RELATION_TYPES_ROOT],
    fetchers,
};

export const useRelationTypesList = createEntityQuery(relationTypesEntity, 'list');

export type { RelationTypesListParams };
